import Vue from 'vue';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import api from '@/utils/api';
import ActionIcons from '@/components/service-log/action-icons/action-icons.vue';
import * as Constants from '@/constants';

export default {
  name: 'ConfirmationPage',
  props: ['submission', 'dialog', 'fromDashboard'],
  components: {
    ActionIcons,
    vueDropzone: vue2Dropzone
  },
  computed: {
    isMobile() {
      return this.$mq === 'mobile';
    }
  },
  data() {
    return {
      submissionData: null,
      errorMsg: null,
      pageReady: false,
      attachmentsDialog: false,
      attachmentData: null,
      dropzoneOptions: {
        url: `${process.env.API_HOST}${Constants.NSL_UPLOAD_ATTACHMENT_URL(this.submission.sessionId)}`,
        thumbnailWidth: 150,
        maxFilesize: 100,
        headers: {
          'Cache-Control': 'no-cache',
          Authorization: Vue.$jwt.hasToken() ? `Bearer ${Vue.$jwt.getToken()}` : ''
        }
      },
      hideFields: false,
      showLoading: false
    };
  },
  methods: {
    handleSlDeleted() {
      this.$emit('close:dialog');
    },
    handleResponse() {
      this.loadPage();
    },
    loadPage() {
      this.pageReady = false;
      api.get(Constants.NSL_GET_NURSING_SESSION_URL(this.submission.sessionId))
        .then((results) => {
          this.submissionData = results.data.data;
          if (this.submissionData.needLevel === Constants.ABSENT) this.hideFields = true;
        })
        .catch((error) => {
          this.errorMsg = error.message;
        })
        .finally(() => {
          this.pageReady = true;
        });
    },
    deleteAttachment(attachmentId) {
      this.pageReady = false
      api.delete(Constants.NSL_DELETE_ATTACHMENT_URL(this.submission.sessionId, attachmentId))
        .then(() => {
          this.loadPage();
        })
        .catch((error) => {
          this.errorMsg = error.message;
        })
        .finally(() => {
          this.pageReady = true;
        });
    },
    getAttachment(attachmentId) {
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = `${process.env.API_HOST}${Constants.NSL_GET_ATTACHMENT_URL(this.submission.sessionId, attachmentId, Vue.$jwt.getToken())}`;
      a.click();
      URL.revokeObjectURL(a.href);
      a.remove();
    }
  },
  filters: {
    createProcedureStringFromArray(val) {
      if (!val || !val.length) return '';
      let string = '';
      for (let i = 0, l = val.length; i < l; i += 1) {
        string += val[i].procedureName;
        if (i < (l - 1)) string += ', ';
      }
      return string;
    }
  },
  watch: {
    dialog() {
      this.loadPage();
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/service-log/history/confirmation-page/confirmation-page.js